import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { MarkCfg, Marks } from './Marks';
import { useSliderContext } from './slider';
import { Box } from '@mantine/core';
export interface TrackProps {
  filled?: number;
  offset?: number;
  marksOffset?: number;
  marks: MarkCfg[];
  min: number;
  max: number;
  value?: number;
  children: React.ReactNode;
  disabled: boolean | undefined;
  containerProps?: React.ComponentProps<'div'>;
}
export function Track(t0) {
  const $ = _c(42);
  let children;
  let containerProps;
  let disabled;
  let filled;
  let marksOffset;
  let offset;
  let others;
  if ($[0] !== t0) {
    ({
      filled,
      children,
      offset,
      disabled,
      marksOffset,
      containerProps,
      ...others
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = containerProps;
    $[3] = disabled;
    $[4] = filled;
    $[5] = marksOffset;
    $[6] = offset;
    $[7] = others;
  } else {
    children = $[1];
    containerProps = $[2];
    disabled = $[3];
    filled = $[4];
    marksOffset = $[5];
    offset = $[6];
    others = $[7];
  }
  const {
    getStyles
  } = useSliderContext();
  let t1;
  if ($[8] !== getStyles) {
    t1 = getStyles("trackContainer");
    $[8] = getStyles;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  let t2;
  if ($[10] !== disabled) {
    t2 = {
      disabled
    };
    $[10] = disabled;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  const t3 = containerProps as any;
  let t4;
  if ($[12] !== getStyles) {
    t4 = getStyles("track");
    $[12] = getStyles;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== disabled) {
    t5 = {
      disabled
    };
    $[14] = disabled;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== disabled) {
    t6 = {
      disabled
    };
    $[16] = disabled;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  const t7 = `calc(${filled}% + var(--slider-size))`;
  const t8 = `calc(${offset}% - var(--slider-size))`;
  let t9;
  if ($[18] !== t7 || $[19] !== t8) {
    t9 = {
      "--slider-bar-width": t7,
      "--slider-bar-offset": t8
    };
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== getStyles) {
    t10 = getStyles("bar");
    $[21] = getStyles;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t6 || $[25] !== t9) {
    t11 = <Box mod={t6} __vars={t9} {...t10} />;
    $[23] = t10;
    $[24] = t6;
    $[25] = t9;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== disabled || $[28] !== marksOffset || $[29] !== others) {
    t12 = <Marks {...others} offset={marksOffset} disabled={disabled} />;
    $[27] = disabled;
    $[28] = marksOffset;
    $[29] = others;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== children || $[32] !== t11 || $[33] !== t12 || $[34] !== t4 || $[35] !== t5) {
    t13 = <Box {...t4} mod={t5}>{t11}{children}{t12}</Box>;
    $[31] = children;
    $[32] = t11;
    $[33] = t12;
    $[34] = t4;
    $[35] = t5;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  let t14;
  if ($[37] !== t1 || $[38] !== t13 || $[39] !== t2 || $[40] !== t3) {
    t14 = <><Box {...t1} mod={t2} {...t3}>{t13}</Box></>;
    $[37] = t1;
    $[38] = t13;
    $[39] = t2;
    $[40] = t3;
    $[41] = t14;
  } else {
    t14 = $[41];
  }
  return t14;
}
Track.displayName = '@mantine/core/SliderTrack';